import { ChevronLeft } from 'lucide-react';
import { Icon } from '../../theme.jsx';

export function TroedelHeader({ title, onBack, onSettings, dark }) {
  return (
    <header className="flex h-[52px] shrink-0 items-center justify-between px-2">
      <div className="flex min-w-0 items-center gap-1">
        {onBack && (
          <button
            onClick={onBack}
            aria-label="Zurück"
            className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-[var(--accent-troedel)] active:bg-[var(--fill-quaternary)]"
          >
            <ChevronLeft className="h-7 w-7" strokeWidth={2.2} />
          </button>
        )}
        <div className={`flex min-w-0 items-center gap-2 ${onBack ? '' : 'pl-3'}`}>
          <div className="flex h-7 w-7 shrink-0 items-center justify-center overflow-hidden rounded-[8px]">
            <img src="/boothly-logo.png" alt="Boothly" className="h-full w-full object-cover" />
          </div>
          <span className="truncate text-[17px] font-semibold">{title}</span>
        </div>
      </div>

      {onSettings && (
        <button
          onClick={onSettings}
          data-testid="troedel-settings-button"
          aria-label="Einstellungen"
          className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-[var(--label-secondary)] active:bg-[var(--fill-quaternary)]"
        >
          {Icon.gear(22)}
        </button>
      )}
    </header>
  );
}
